import { IUser, IUserAuthenticated, IUserGaData } from '../../types/user';
import { ISopr1User, ESopr1UserTypes } from '../../types/analytics';

interface IGetUserDataForTrackingParams {
  userData?: IUser;
  userGaData?: IUserGaData | void;
  abGroup: number;
}

const isUserAuthenticated = (userForCheck?: IUser): userForCheck is IUserAuthenticated => {
  return !!userForCheck?.isAuthenticated;
};

export function getUserDataForTracking({ userData, userGaData, abGroup }: IGetUserDataForTrackingParams): ISopr1User {
  const userTrackingData: ISopr1User = {
    abGroup: userGaData && userGaData.abGroup ? Number(userGaData.abGroup) : abGroup,
    // type - обязательное поле, но апи может таймаутить и тогда оно будет пустым
    type: ((userGaData && userGaData.userType) || '') as ESopr1UserTypes,
  };

  if (isUserAuthenticated(userData)) {
    userTrackingData.balance = userData.balance ?? undefined;
    userTrackingData.email = userData.email || '';
    userTrackingData.userId = userData.userId ?? undefined;
    userTrackingData.cianUserId = userData.id ?? undefined;
    userTrackingData.type = userTrackingData.type || userData.userType || '';
  }

  return userTrackingData;
}
